import { combineReducers } from '@reduxjs/toolkit';
import connectivitySaga from '@state/features/connectivity.saga';
import connectivitySlice from '@state/features/connectivity.slice';
import { all, fork } from 'redux-saga/effects';
import accordionStepsSaga from './accordion.saga';
import accordionstepsSlice from './accordion.slice';
export const connectivityRootReducer = combineReducers({
    connectivity: connectivitySlice.reducer,
    step: accordionstepsSlice.reducer,
});
export function* connectivityRootSaga() {
    yield all([fork(connectivitySaga), fork(accordionStepsSaga)]);
}
